var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisibilityOffLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9301_22352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7582 38.963L9.61816 10.543L11.1815 8.99512L39.3215 37.4151L37.7582 38.963Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 28.4399C21.95 28.4399 20.2 26.6899 20.2 24.5399C20.2 22.8199 21.33 21.3699 22.88 20.8499L21.21 19.1699C19.3 20.1999 18 22.2199 18 24.5399C18 27.8999 20.74 30.6399 24.1 30.6399C26.4 30.6399 28.4 29.3599 29.44 27.4799L27.77 25.7999C27.24 27.3299 25.8 28.4399 24.1 28.4399Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2001 24.5395C30.2001 21.1795 27.4601 18.4395 24.1001 18.4395C23.9301 18.4395 23.7701 18.4495 23.6101 18.4595L30.1701 25.0895C30.1901 24.9095 30.2001 24.7295 30.2001 24.5395Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0999 16.1397C32.7699 16.1397 36.1599 22.5497 36.9899 24.5697C36.6499 25.3797 35.7299 27.2197 33.9999 28.9597L35.5499 30.5197C37.5499 28.4897 38.6199 26.3597 39.0099 25.4197C39.2499 24.8497 39.2499 24.2197 39.0099 23.6397C38.0399 21.3597 34.1099 13.9297 24.0899 13.9297C22.5399 13.9297 21.0599 14.1197 19.6599 14.4797L21.4999 16.3397C22.3299 16.1997 23.1999 16.1297 24.0899 16.1297L24.0999 16.1397Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.91 30.7093C29.69 32.1893 27.06 32.9393 24.1 32.9393C15.43 32.9393 12.04 26.5293 11.21 24.5693C11.21 24.5493 11.21 24.5293 11.21 24.5093C11.7 23.3593 13.62 19.4693 17.95 17.4293C18.28 17.2693 18.63 17.1293 19 16.9893C19.02 16.9893 19.03 16.9793 19.05 16.9693L17.38 15.2793C17.26 15.3293 17.14 15.3793 17.02 15.4293C12.12 17.7393 9.9 21.9493 9.18 23.6493C8.94 24.2193 8.94 24.8493 9.18 25.4193C10.15 27.6993 14.08 35.1293 24.1 35.1293C27.5 35.1293 30.54 34.2593 33.13 32.5293C33.4 32.3493 33.65 32.1593 33.9 31.9693L32.33 30.3893C32.19 30.4893 32.05 30.5993 31.91 30.6993V30.7093Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9301_22352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.32,
    height: 29.97,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOffLight);
export default __webpack_public_path__ + "static/media/icon_visibility_off_light.47fdccd5.svg";
export { ForwardRef as ReactComponent };